import React, { useState, useEffect, useRef } from 'react'
import { Col, Image } from 'react-bootstrap'
import styleClasses from "../../../../src/components/ItemGrid/ItemGrid.module.scss"
import * as CONSTANT from "../../../constants";
import FavoriteButton from '../../../containers/try2/Customization/FavoriteButton'
import TagSymbol from '../../Molecules/Symbols/Symbol'
import { useAuthState } from '../../../context/UserAuthentication';
import { availableForSelectedOrderType, verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useLocation } from 'react-router';
import { isItCreateYourOwnItem } from '../../../helpers/helperMethods';

interface IItemDescriptionDetail {
  item: any
  favourites: { id: number; item_id: number; isSelected: boolean; }[]
  favoriteButtonHandler: any
  showDetailsHandler: any
  locationInfo: any
  orderType: any
  catering_menus: string
  filteredIitems: any[]
  discountApplied: any
  getClories: (item: any) => string
  orderClickHandler: any
}

const ItemDescriptions: React.FC<IItemDescriptionDetail> = (props) => {

  const { item, favourites, favoriteButtonHandler, showDetailsHandler, locationInfo, orderType, catering_menus, filteredIitems, discountApplied, getClories, orderClickHandler } = props;

  const [divHeight, setDivHeight] = useState(0);
  const itemHeight = useRef(null);
  const heightSetRef = useRef(null);
  const { authInfo } = useAuthState();
  const [isDeviceIos, setIsDeviceIos] = React.useState<boolean>(false);
  const [isItemActive, setIsItemActive] = React.useState<boolean>(false);
  const [isAvailableForOrderType, setIsAvailableForOrderType] = React.useState<boolean>(false);
  const isItMobile = useCheckMobileScreen();
  const location = useLocation()


  useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
      setIsDeviceIos(true);
    } else {
      setIsDeviceIos(false);
    }
  }, []);

  useEffect(() => {
    if (checkIsItemActive()) setIsItemActive(true)
    else setIsItemActive(false)
  }, [item])

  const showFavrtButton = (item) => {
    if (authInfo.userId && authInfo.type !== CONSTANT.GUEST_USER && !isItCreateYourOwnItem(item?.is_create_your_own)) {
      return true
    }
    return false
  }
  useEffect(() => {
    if ((!divHeight || divHeight <= 0) && itemHeight?.current && itemHeight?.current?.scrollHeight && filteredIitems.length && heightSetRef?.current === null) {
      setDivHeight(itemHeight?.current?.scrollHeight);
      heightSetRef.current = true;
    }
  }, [filteredIitems, location.pathname]);

  const attachClickHandlerWithItemWidget = (item: any) => {
    if (item.is_active && verifyStatus(item, "item_location")) {
      if (availableForSelectedOrderType(item, orderType)) {
        return true
      }
    }
    return false
  }

  const checkBadge = (item: any) => {
    let discountItem = null;
    if (discountApplied) {
      discountItem = discountApplied.find(
        (rewardItem) => rewardItem.item_id == item.id
      );
    }
    if (discountItem)
      return (
        <Image
          src={`${CONSTANT.REACT_APP_CLOUD_FRONT}/images/icons/redeem-badge.svg`}
          className={`${styleClasses.badge_img} img-fluid`}
          alt="redeem badge"
        />
      );
    else return null;
  };

  const checkIsItemActive = () => {
    const itemStatus = verifyStatus(item, "item_location");
    const availableForOrderType = availableForSelectedOrderType(item, orderType);
    setIsAvailableForOrderType(availableForOrderType);
    return item.is_active &&
      itemStatus &&
      availableForOrderType
  }

  return (
    <>
      <Col
        key={item.id}
        lg="4"
        md="4"
        sm="12"
        className={`${styleClasses.car_col} p-0 gap-item`}
      >
        <div
          className={`${styleClasses.item_main_div} d-flex flex-column h-100`}
          onClick={(e) => attachClickHandlerWithItemWidget(item) ? orderClickHandler(e, item) : ""}
          data-testid='menu-item'
        >
          <div className={styleClasses.item_img_wrap}>
            {checkBadge(item)}
            <Image
              src={
                `${CONSTANT.REACT_APP_CLOUD_FRONT}/Items/${item.id}/item-${item.id}.webp?v=${item?.image_version || Date.now()}`
              }
              width="200"
              height="200"
              rounded
              className={isItemActive ? '' : `${styleClasses.is_not_active}`}
              alt= {item.name}
            />
            {showFavrtButton(item) && (
              <FavoriteButton
                favIcon={true}
                buttonHandler={favoriteButtonHandler}
                className={`${styleClasses.favbtn} d-none d-md-block`}
                item={item}
                favourite={favourites.some(
                  (fav) => fav.item_id === item.id
                )} isIconblueFill={false}              />
            )}
          </div>
          <div
            className={`${styleClasses.item_title_wrap} menu-title d-flex align-items-start justify-content-start text-start`}
          >
            <div className="d-flex flex-fill">
              <h3 className="sub_title1 sub_title1_item">
                {item.name}
              </h3>
              <div className='d-none d-md-block'>
                <TagSymbol tags={item.tags} />
              </div>

            </div>
            {showFavrtButton(item) && (
              <FavoriteButton
                favIcon={true}
                buttonHandler={favoriteButtonHandler}
                className={`${styleClasses.favbtn} position-static d-md-none`}
                item={item}
                favourite={favourites.some(
                  (fav) => fav.item_id === item.id
                )} isIconblueFill={false}              />
            )}
          </div>
          <div className='d-md-none my-1'>
              <TagSymbol tags={item.tags} />
            </div>
          <p
            ref={itemHeight}
            className={`${styleClasses.item_subtitle_wrap} text-start mb-0 p-16`}
          >
            {item.description}
          </p>
          <p className={`${styleClasses.showMore} text-end p-16`}>
            {divHeight > 58 && <button
              type="button"
              className={`${styleClasses.item_subtitle_button} btn btn-custom p-0 f-w6 p-16`}
              onClick={(e) => showDetailsHandler(e, item)}
            >
              Show more
            </button>}
          </p>
          {isItemActive ? (
            <button
            // id={item.id}
              className={
                catering_menus
                  ? "btn btn-large w-100 mx-auto mw-auto"
                  : "btn btn-large w-100 mx-auto mw-auto"
              }
              data-testid='add-to-order'
            >
              ORDER
            </button>
          ) : (
            <button
              disabled={true}
              className={
                catering_menus
                  ? "btn btn-large w-100 mx-auto mw-auto"
                  : "btn btn-large w-100 mx-auto mw-auto"
              }
              data-testid='disable-to-order'
            >
              {isAvailableForOrderType ? 'Unavailable' :
               `Unavailable for 
               ${orderType == CONSTANT.PICK_UP_ORDER_TYPE ? 'Pick-up' : 'Delivery'}`}
            </button>
          )}
        </div>
      </Col>
    </>
  )
}

export default ItemDescriptions